/**
 * Labstep
 *
 * @module components/Experiment/Action/Bar
 * @desc Action Bar for Experiment
 */

import EntityActionPrint from 'labstep-web/components/Entity/Action/Print';
import { ExperimentActionLock } from 'labstep-web/components/Experiment/Action/Lock';
import ExperimentActionStartEnd from 'labstep-web/components/Experiment/Action/StartEnd';
import { Divider } from 'labstep-web/core/Divider';
import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';
import styles from './styles.module.scss';
import type { ExperimentActionBarProps } from './types';

export const ExperimentActionBar: React.FC<
  ExperimentActionBarProps
> = ({ experiment, editAction, actions }) => (
  <div className={styles.container}>
    <Flex className={styles.actionContainer}>
      <ExperimentActionStartEnd
        experiment={experiment}
        showReverse={false}
      />
      {editAction}
      <EntityActionPrint
        entity={experiment}
        actionComponentProps={{ type: 'text' }}
      />
      <ExperimentActionLock
        experiment={experiment}
        actionComponentProps={{ type: 'text' }}
      />
      {actions}
    </Flex>
    <Divider className={styles.divider} />
  </div>
);
